module.exports = __webpack_public_path__ + "static/img/14.8c8e8a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITInfrastructure/14.png
// module id = nj7j
// module chunks = 1